/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Wed Feb 05 2025
 **/

import { create } from "zustand";

type WhiteboardState = {
	enableFECameraFeed: boolean;
	currentZoneId: string;
	debugFileInfo: WhiteboardService.FileInfo | null;
};

type WhiteboardAction = {
	setCurrentZoneId: (currentZoneId: string) => void;
	setEnableFECameraFeed: (enableFECameraFeed: boolean) => void;
	setDebugFileInfo: (domain: string, debugFileInfo: SwaggerFileAPIModels.FileBoxResponse | null) => void;
};

type WhiteboardStoreProps = WhiteboardState & WhiteboardAction;

const DefaultWhiteboardState: WhiteboardState = {
	enableFECameraFeed: true,
	currentZoneId: "",
	debugFileInfo: null
};

const useWhiteboardStore = create<WhiteboardStoreProps>((set) => ({
	...DefaultWhiteboardState,
	setCurrentZoneId: (currentZoneId: string) => set(() => ({ currentZoneId })),
	setEnableFECameraFeed: (enableFECameraFeed) => set(() => ({ enableFECameraFeed })),
	setDebugFileInfo: (domain, file) =>
		set(() => ({
			debugFileInfo: {
				createdBy: file?.createBy || "",
				fileID: file?.id || "",
				fileName: file?.name || "",
				fileMimeType: file?.fileMimeType || "",
				filePath: `${domain}${file?.filePath}`,
				createDateTime: file?.createDateTime || 0,
				fileDisplaySize: file?.fileDisplaySize || ""
			}
		}))
}));

export default useWhiteboardStore;
